var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-300px mr-3"},[_c('v-autocomplete',{attrs:{"value":_vm.selectedWarehouse,"label":"Warehouse","items":_vm.$store.getters.getUserWareHouses,"item-text":"text","item-value":"index","dense":"","outlined":"","clearable":"","hide-details":"","hide-spin-buttons":""},on:{"input":_vm.setWarehouse}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }